import { createCarousel, CarouselConfig } from "utils/carousel"
import "./index.scss"

require.context("./static", true, /\.jpg|svg$/)

// Component-specific configuration
const config: CarouselConfig = {
  carouselSelector: ".carousel-popular-mountains__carousel",
  slideSelector: ".carousel-popular-mountains__carousel__slide",
  slideGap: 20,
  cssClass: "carousel-popular-mountains",
}

// Export the configured carousel instance
export const CarouselPopularMountains = createCarousel(config)
